/**
 * Ready Status
 */
export var ReadyStatusEnum;
(function (ReadyStatusEnum) {
    ReadyStatusEnum[ReadyStatusEnum["Pending"] = 0] = "Pending";
    ReadyStatusEnum[ReadyStatusEnum["Ready"] = 1] = "Ready";
    ReadyStatusEnum[ReadyStatusEnum["Failed"] = -1] = "Failed";
})(ReadyStatusEnum || (ReadyStatusEnum = {}));
export function wait(name) {
    let readyStatus = ReadyStatusEnum.Pending;
    let resultValue;
    let waitPromise;
    let waitPromiseResolve;
    let waitPromiseReject;
    const setResult = (status, value) => {
        // skip set to same status
        if (readyStatus === status) {
            return;
        }
        // cannot set ready status to fail or vice vesa
        if (readyStatus !== ReadyStatusEnum.Pending && status !== ReadyStatusEnum.Pending) {
            return;
        }
        readyStatus = status;
        resultValue = value;
        switch (status) {
            case ReadyStatusEnum.Ready:
                if (waitPromiseResolve) {
                    waitPromiseResolve(resultValue);
                }
                break;
            case ReadyStatusEnum.Failed:
                if (waitPromiseReject) {
                    waitPromiseReject(resultValue);
                }
                break;
            default:
                break;
        }
        waitPromiseResolve = null;
        waitPromiseReject = null;
        waitPromise = null;
    };
    const targeName = name !== null && name !== void 0 ? name : '';
    return {
        [`after${targeName}Ready`]: () => {
            switch (readyStatus) {
                case ReadyStatusEnum.Ready:
                    return Promise.resolve(resultValue);
                case ReadyStatusEnum.Failed:
                    return Promise.reject(resultValue);
                case ReadyStatusEnum.Pending:
                default:
                    break;
            }
            if (!waitPromise) {
                waitPromise = new Promise((resolve, reject) => {
                    waitPromiseResolve = resolve;
                    waitPromiseReject = reject;
                });
            }
            return waitPromise;
        },
        [`set${targeName}Ready`]: (value) => {
            setResult(ReadyStatusEnum.Ready, value);
        },
        [`set${targeName}Failed`]: (reason) => {
            setResult(ReadyStatusEnum.Failed, reason);
        },
        [`get${targeName}Status`]: () => readyStatus,
        [`get${targeName}ResultValue`]: () => resultValue,
        [`get${targeName}FailReason`]: () => resultValue,
        [`reset${targeName}`]: () => {
            setResult(ReadyStatusEnum.Pending, undefined);
        },
    };
}
